
    import Vue from "vue";
    import Component from "vue-class-component";

    // this component can be removed in future!
    // (just here in case any old signature links a floating around)

    @Component({})
    export default class SignWorkPermit extends Vue {
    }
